import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { useCallback } from 'react';
import cx from 'classnames';
var css = {
  "row": "oalp-mf2L-",
  "column": "oalp-19Bk2",
  "title": "oalp-2Pqys",
  "subtitle": "oalp-11AW_",
  "width_3": "oalp-2XtWc",
  "width_2": "oalp-3g78f",
  "width_1": "oalp-3oZ0w",
  "fullWidth": "oalp-3YvT0"
};
import ImageWrapper from "../../Components/ImageWrapper/ImageWrapper";
import CTA from "../../Components/CTA/CTA";
import { withComponentDependency } from "../../ComponentDependency/withComponentDependency";
import { UNKNOWN } from "../../Constants/locations";
import { compose } from 'redux';
import UserSession from "../../Utils/UserSession";
import { withRouter } from "../../Helpers/withRouter";
import TrackingInfoManager from "../../Utils/TrackingInfoManager";
import TitleComponent from "../../Components/Title/Title";
import SubSection from "../../Components/SubSection/SubSection";
var EqualWidthColumnStaticContent = function EqualWidthColumnStaticContent(_ref) {
  var name = _ref.name,
    data = _ref.data,
    metadata = _ref.metadata,
    ReactObserver = _ref.ReactObserver,
    track = _ref.track,
    handleClick = _ref.handleClick,
    classname = _ref.classname,
    selectedClassName = _ref.selectedClassName,
    locationId = _ref.locationId,
    browsingMode = _ref.browsingMode,
    origin = _ref.origin,
    _ref$showObserver = _ref.showObserver,
    showObserver = _ref$showObserver === void 0 ? true : _ref$showObserver;
  var _ref2 = metadata || {},
    widgetStyle = _ref2.style;
  var handleChange = useCallback(function (inView) {
    if (inView && track && metadata && metadata.trackingInfo && metadata.trackingInfo.impressionEvent && metadata.trackingInfo.impressionEvent.name) {
      var trackingInfo = TrackingInfoManager.getTrackingInfo({
        browsing_location_id: locationId || UNKNOWN,
        browsing_mode: browsingMode,
        origin: origin,
        select_from: metadata.trackingInfo.impressionEvent.selectFrom
      });
      track(metadata.trackingInfo.impressionEvent.name, trackingInfo);
    }
  }, [browsingMode, locationId, origin, track, metadata]);
  return /*#__PURE__*/React.createElement("div", {
    className: css.row,
    style: widgetStyle
  }, ReactObserver && showObserver && /*#__PURE__*/React.createElement(ReactObserver, {
    as: 'div',
    onChange: handleChange,
    "data-aut-id": "observer",
    triggerOnce: true
  }), data.map(function (col, index) {
    var _cx;
    var image = col.image,
      title = col.title,
      subtitle = col.subtitle,
      cta = col.cta,
      _col$isSelected = col.isSelected,
      isSelected = _col$isSelected === void 0 ? false : _col$isSelected,
      customClass = col.className,
      styledClass = col.styledClass,
      subSection = col.subSection;
    return /*#__PURE__*/React.createElement("div", {
      key: "col_".concat(index),
      "data-index": index,
      className: cx(css.column, (_cx = {}, _defineProperty(_cx, classname, classname), _defineProperty(_cx, selectedClassName, selectedClassName && isSelected), _defineProperty(_cx, css["width_".concat(data.length)], !classname), _defineProperty(_cx, customClass, customClass), _defineProperty(_cx, css[styledClass], styledClass), _cx)),
      onClick: handleClick
    }, image && /*#__PURE__*/React.createElement(ImageWrapper, {
      image: image
    }), title && /*#__PURE__*/React.createElement(TitleComponent, {
      className: css.title,
      title: title
    }), subtitle && /*#__PURE__*/React.createElement(TitleComponent, {
      className: css.subtitle,
      title: subtitle
    }), subSection && /*#__PURE__*/React.createElement(SubSection, Object.assign({}, subSection)), cta && cta.buttons && cta.buttons.map(function (btn, idx) {
      var _a, _b;
      return /*#__PURE__*/React.createElement(CTA, {
        key: idx,
        widgetKey: name,
        button: btn,
        track: track,
        select_from: ((_b = (_a = metadata === null || metadata === void 0 ? void 0 : metadata.trackingInfo) === null || _a === void 0 ? void 0 : _a.clickEvent) === null || _b === void 0 ? void 0 : _b.selectFrom) || UserSession.getTabName(),
        "data-aut-id": (btn === null || btn === void 0 ? void 0 : btn.name) || name,
        metadata: metadata
      });
    }));
  }));
};
export { EqualWidthColumnStaticContent };
export default compose(withComponentDependency, withRouter)(EqualWidthColumnStaticContent);